import { render, staticRenderFns } from "./DesktopBetaDownload.vue?vue&type=template&id=12351eb4&scoped=true"
import script from "./DesktopBetaDownload.vue?vue&type=script&lang=ts"
export * from "./DesktopBetaDownload.vue?vue&type=script&lang=ts"
import style0 from "./DesktopBetaDownload.vue?vue&type=style&index=0&id=12351eb4&lang=scss&scoped=true"
import style1 from "./DesktopBetaDownload.vue?vue&type=style&index=1&id=12351eb4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12351eb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12351eb4')) {
      api.createRecord('12351eb4', component.options)
    } else {
      api.reload('12351eb4', component.options)
    }
    module.hot.accept("./DesktopBetaDownload.vue?vue&type=template&id=12351eb4&scoped=true", function () {
      api.rerender('12351eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/DesktopBetaDownload.vue"
export default component.exports